import React from 'react'
import img1 from "../../../assets/images/img1.png"
import  { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function Knowsomething() {
    useEffect(() => {
          AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: false,
            offset: 100,  // Trigger when the element is 100px from the viewport
        delay: 200, // Whether animation should happen only once
          });
        }, []);
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 lg:gap-2 md:gap-0 items-center mt-10">

                <div
                    className="col-span-3  p-6  flex flex-col justify-center h-full md:pl-12"
                    data-aos="fade-right"
                >
                    <h2 className="text-3xl md:text-4xl xl:text-5xl font-bold text-gray-900 mb-4 oxygen">
                    Know Something <span className='text-[#214293]'>About Us</span> !
                    </h2>
                    <p className="text-[#868686] lg:text-[1.1rem] md:max-w-[95%] poppins xl:text-lg lg:text-sm md:text-sm text-sm ">
                    Welcome to Drivesafe Solutions, your trusted FASTag service provider India. We are a leading FASTag Supplier in India dedicated to simplifying toll payments and improving your overall travel experience through our reliable and convenient ecosystem.
                    </p>
                    <p className="text-[#868686] lg:text-[1.1rem] md:max-w-[95%] poppins xl:text-lg lg:text-sm md:text-sm text-sm">
                    At Drivesafe , we offer a range of FASTag services, including account creation, tag issuance, recharge, and customer support, among others. Our aim is to provide you with a seamless and hassle-free experience, whether you are a regular commuter or a first-time user of FASTag.
                    </p>
                </div>
                <div className='flex lg:justify-start justify-center items-center col-span-2 lg:h-auto hover:scale-105 transform transition-transform duration-300'>
                <img
                    alt="Live"
                    src={img1}
                    className="col-span-2  xl:w-[90%] md:w-[85%] w-[100%] h-[350px] lg:h-auto hover:scale-105 transform transition-transform duration-300 pl-4 sm:pl-0"
                    data-aos="fade-left"
                />
                </div>
            </div>
  )
}

export default Knowsomething


